const DOC_UPLOAD_ALLOWED_EXTENSIONS = new Set([
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".mp3",
  ".wav",
  ".mp4",
  ".webm",
]);

export const DOC_UPLOAD_ACCEPT_ATTR = [
  ...Array.from(DOC_UPLOAD_ALLOWED_EXTENSIONS).sort((a, b) => a.localeCompare(b)),
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "audio/*",
  "video/*",
].join(",");

/**
 * @param {File} file
 * @returns {boolean}
 */
export function fileMatchesCourseDocUploadAccept(file) {
  if (!(file instanceof File)) {
    return false;
  }
  const lowerName = typeof file.name === "string" ? file.name.toLowerCase() : "";
  const dot = lowerName.lastIndexOf(".");
  const extension = dot >= 0 ? lowerName.slice(dot) : "";
  if (extension && DOC_UPLOAD_ALLOWED_EXTENSIONS.has(extension)) {
    return true;
  }
  const type = typeof file.type === "string" ? file.type.toLowerCase() : "";
  return (
    type === "application/pdf" ||
    type === "application/msword" ||
    type.includes("wordprocessingml") ||
    type.includes("ms-excel") ||
    type.includes("spreadsheetml") ||
    type.startsWith("audio/") ||
    type.startsWith("video/")
  );
}
